import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { AttendanceLogbookItem } from "src/apis/dashboardAttendance";
import { formatDateToBR } from "src/utils/date";

type AttendanceLogbookTableProps = {
  data: AttendanceLogbookItem[];
};

const observationColor = (
  observacao: string
): "success" | "warning" | "error" | "default" => {
  if (observacao.startsWith("Boa adesão")) return "success";
  if (observacao.startsWith("Alta taxa de faltas")) return "error";
  if (observacao.startsWith("Cancelamentos")) return "warning";
  if (observacao.startsWith("Empresa sem atendimentos")) return "default";
  return "default";
};

const AttendanceLogbookTable: FC<AttendanceLogbookTableProps> = ({
  data,
}): JSX.Element => {
  return (
    <Paper variant="outlined" sx={{ padding: 2, display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Diário de Bordo
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>Data</strong></TableCell>
              <TableCell><strong>Empresa</strong></TableCell>
              <TableCell><strong>Unidade</strong></TableCell>
              <TableCell align="center"><strong>Marcados</strong></TableCell>
              <TableCell align="center"><strong>Realizados</strong></TableCell>
              <TableCell align="center"><strong>Cancelados</strong></TableCell>
              <TableCell align="center"><strong>Faltas</strong></TableCell>
              <TableCell align="center"><strong>Comparecimento</strong></TableCell>
              <TableCell><strong>Observação</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item) => (
              <TableRow key={`${item.date}-${item.company_id}`} hover>
                <TableCell>{formatDateToBR(item.date)}</TableCell>
                <TableCell>{item.company_name ?? "—"}</TableCell>
                <TableCell>{item.unit ?? "—"}</TableCell>
                <TableCell align="center">{item.scheduled}</TableCell>
                <TableCell align="center">{item.completed}</TableCell>
                <TableCell align="center">{item.cancelled}</TableCell>
                <TableCell align="center">{item.no_show}</TableCell>
                <TableCell align="center">{item.attendance_rate}%</TableCell>
                <TableCell>
                  <Chip
                    label={item.observacao}
                    color={observationColor(item.observacao)}
                    size="small"
                    variant="outlined"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default AttendanceLogbookTable;
